<template>
    <v-container fluid> </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class CMExpenseReport extends Vue {
    /**
     * @param {Json} params paramettre d'affichage
     * Liste de tous les paramettres
     * {
     *   document:['vatRate', 'vatamount', 'netAmount', 'grossAmout', 'invoiceNumber', clientCompanies],
     *   bank:[''],
     *   others: ['date', 'amount', 'accountableAccount', 'text']
     * }
     */

    @Prop({ default: [] }) params: any;
    @Prop({ default: "" }) id: string;
}

export default toNative(CMExpenseReport);
</script>
